module.exports = __webpack_public_path__ + "img/ic-copy.3e8f1419.svg";